import axios from 'axios';
import PostCache from './PostCache';
import { getBaseUrl } from '../utils';
import { SummaryConstants as Constants } from '../Helpers/summaryconstants';

export default class TcciService {
    language = "";
    province = "";
    postCache = null;

    constructor() {
        this.postCache = new PostCache(axios);
    }


    /*
        Calculate the total residual value on the color and accessories
    */
    getResidualTotal(summaryCalculator) {
        if (!summaryCalculator.SelectedColourExterior || !summaryCalculator.SelectedColourInterior) {
            return 0;
        }

        //let extColorValue = summaryCalculator.SelectedColourExterior.price ? summaryCalculator.SelectedColourExterior.price : 0;
        //let intColorValue = summaryCalculator.SelectedColourInterior.price ? summaryCalculator.SelectedColourInterior.price : 0;

        let totalAccessoriesResidualValue = 0;

        let accesories = Object.entries(summaryCalculator.SelectedAccessories);
        accesories.forEach((accessory) => {
            const residualValue = Number(accessory[1].residual_value ? accessory[1].residual_value : 0);

            // Fix arithmetic error when adding accessories residual value and we ended up with a bunch of 0000000001 at the end
            totalAccessoriesResidualValue = Math.round((Number(totalAccessoriesResidualValue) + residualValue) * 100) / 100;
        })

        let residualTotal = Math.round((totalAccessoriesResidualValue) * 100) / 100;
        
        //console.log(residualTotal, extColorValue, intColorValue, accessoriesValue);
        return residualTotal;
    }

    /*
        Handle the reqest sent to provider and has a post cache object to not send multiple time the same post 
    */
    async handleRequest(url, data) {
        const mockedModels = [...window.mockedModels];

        const startsWithAny = mockedModels.some(str => data.Identifier.startsWith(str));

        if (startsWithAny) {
            const mock = require('./tcciMock.json');
            return mock.QuoteResponse;
        }

        const cachedUrls = [
            {
                url: url,
                bodyParams: [JSON.stringify(data)],
            },
        ]
        this.postCache.setCachedUrls(cachedUrls);

        const requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                'x-requested-with': 'XMLHttpRequest'
            },
            body: JSON.stringify(data)
        };

        try {
            const responseData = await this.postCache.post(url, data, requestOptions);

            return responseData.data.QuoteResponse;
        } catch (err) {
            console.log('Failed to fetch data from payment provider:', err);

            return {}; //return await this.handleRequest(url, data);
        }
    }


    /*
        build the body to be sent to provider to retrieve the information

        it depends of the summarycalculator object, note that some parameter has started to be decoupled from the summarycalculator object in preparation for the refactoring

        productKey param can be both / loan / lease
    */
    buildBodyJson(summaryCalculator, withFees, withRebates, productKey, term, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, selectedAnnualMileage = 0) {
        if (!summaryCalculator) {
            return {}
        }

        if (!summaryCalculator.SelectedModel) {
            return {}
        }

        const financialObj = summaryCalculator.FinancialInfo;

        const mazdaCashIncentive = financialObj.incentive_programs.filter((fee) => fee.title === 'mazda_retail_cash').length ? summaryCalculator.FinancialInfo.incentive_programs.filter((fee) => fee.title === 'mazda_retail_cash')[0].price : 0;

        const loyaltyPriceRate = (loyaltyChecked ? loyaltyChecked : summaryCalculator.LoyaltyChecked) ? financialObj.incentive_programs.find(x => x.type === "loyalty").rate_value : 0;
        const loyaltyPrice = (loyaltyChecked ? loyaltyChecked : summaryCalculator.LoyaltyChecked) ? financialObj.incentive_programs.find(x => x.type === "loyalty").cash_value : 0;
        const graduatePrice = (graduateChecked ? graduateChecked : summaryCalculator.GraduateChecked) ? financialObj.incentive_programs.find(x => x.type === "grad_award").value : 0;
        const militaryPrice = (militaryChecked ? militaryChecked : summaryCalculator.MilitaryChecked) ? financialObj.incentive_programs.find(x => x.type === "military").value : 0;
        const firstTimeOwnerPrice = (firstTimeOwnerChecked ? firstTimeOwnerChecked : summaryCalculator.FirstTimeOwnerChecked) ? financialObj.incentive_programs.find(x => x.type === "first_time_owner").value : 0;

        // DO NOT ADD THE EV RABATE INCENTIVE IN, THIS IS CALCULATED BY THE FLAG ISEV ON PROVIDER SIDE
        const incentives = mazdaCashIncentive + graduatePrice + militaryPrice + firstTimeOwnerPrice + financialObj.calculatedFinance.specialIncentives;

        const modelCode = summaryCalculator.SelectedModel.model_code;
        const packageCode = summaryCalculator.SelectedPackage.option_code;

        //content += `<li class="mz-finance-options__financial-element"><span><label for="annualMileage">${t("annual_km_16000")}</label><input type="hidden" name="annualMileage" value="3"} id="ultra_kilometer_lease"/></span></li>`;
        //content += `<li class="mz-finance-options__financial-element"><span><label for="annualMileage">${t("annual_km_20000")}</label><input type="hidden" name="annualMileage" value="2"} id="low_kilometer_lease"/></span></li>`;
        //content += `<li class="mz-finance-options__financial-element"><span><label for="annualMileage">${t("annual_km_24000")}</label><input type="hidden" name="annualMileage" value="0"} id="standard_kilometer_lease"/></span></li>`;
        // TODO : MOVE THIS INTO THE UTILITY CLASS FOR REUSABILITY WITH LEASE OPTIONS
        let annualMileage = '24000';
        switch (selectedAnnualMileage) {
            case 3:
                annualMileage = '16000';
                break;
            case 2:
                annualMileage = '20000';
                break;
            case 0:
            default:
                annualMileage = '24000';
        }

        const baseMSRP = Math.round((summaryCalculator.SelectedModel.financial.msrp 
            + summaryCalculator.SelectedPackage.financial.msrp
            + (summaryCalculator.SelectedColourExterior ? summaryCalculator.SelectedColourExterior.price : 0)
            + (summaryCalculator.SelectedColourInterior ? summaryCalculator.SelectedColourInterior.price : 0)) * 100) / 100;

        const options = summaryCalculator.SelectedWheel ? summaryCalculator.SelectedWheel.price : 0 //financialObj.calculatedFinance.options.total  // Wheels
            + summaryCalculator.SelectedNonModelPackage.financial.msrp
            + summaryCalculator.SelectedWarrantyPackage.financial.msrp // Warranty 
            + summaryCalculator.SelectedConnectedVehiclePackage.financial.msrp // Connected Vehicle 
            + summaryCalculator.SelectedAddedProtectionPackage.financial.msrp // Added Protection
            + summaryCalculator.SelectedAppearanceProtectionPlansPackage.financial.msrp // Appearance Protection
            + financialObj.calculatedFinance.accessories.total; // Accesories  

        const totalMSRP = summaryCalculator.SelectedModel.financial.msrp
            + summaryCalculator.SelectedPackage.financial.msrp // Actual Car packages          
            + options
            + financialObj.exciseTax + financialObj.freight + financialObj.pde
            + (withFees ? financialObj.acTax + financialObj.amvic + financialObj.omvic + financialObj.tireStewardshipFee + financialObj.oil : 0);

        // TODO: MOVE THIS LOGIC INTO THE SUMMARYCALCULATOR BUSINESS LOGIC CLASS
        // Validate that trade-in value doesn't exceed max amount
        let tradeInVal = parseInt(summaryCalculator._tradeInValue, 10);
        // Tradein : Min: 0 , Max:  (TotalMSRP-10000) 
        if (parseInt(tradeInVal) > financialObj.maxDownPayment) {
            tradeInVal = financialObj.maxDownPayment;
            summaryCalculator.DownPaymentValue = 0;
        } else if (parseInt(tradeInVal) + financialObj.downPaymentValue > financialObj.maxDownPayment) {
            summaryCalculator.DownPaymentValue = financialObj.maxDownPayment - parseInt(tradeInVal);
        }

        if (typeof tradeInVal === 'string' && tradeInVal.length > 0) {
            summaryCalculator.TradeInValue = `$${tradeInVal}`;
        } else {
            summaryCalculator.TradeInValue = tradeInVal;
        }

        // Check if the balance is under 7500$, if so update the downpayment
        if (summaryCalculator.IncludeFees ? (financialObj.calculatedFinance.balanceToFinance < 7500 || financialObj.calculatedLease.leaseEndValue < 3000) : (financialObj.calculatedFinance.balanceToFinanceNoFees < 7500 || financialObj.calculatedLease.leaseEndValueNoFees < 3000)) {
            summaryCalculator.TradeInValue = 0;
            summaryCalculator.DownPaymentValue = 0;
        }

        return {
            "Identifier": `${modelCode}${packageCode}`, //`VXLP84AA00`
            "BaseMSRP": Number.parseFloat(Number.parseFloat(baseMSRP).toFixed(2)),
            "ConfiguredOptions": Number.parseFloat(Number.parseFloat(options).toFixed(2)),
            "TotalMSRP": Number.parseFloat(Number.parseFloat(totalMSRP).toFixed(2)),
            "Province": `${this.province}`,
            "TotalResidualizedOptions": Number.parseFloat(Number.parseFloat(this.getResidualTotal(summaryCalculator)).toFixed(2)),
            "Parameters": {
                "ProductKey": productKey, //"both/loan/lease",
                "Downpayment": Number.parseFloat(Number.parseFloat(summaryCalculator._downPaymentValue).toFixed(2)),
                "TradeInValue": Number.parseFloat(Number.parseFloat(summaryCalculator._tradeInValue).toFixed(2)),
                "TradeInOwed": 0,
                "LeaseTerm": productKey === 'lease' ? Number.parseInt(term) : 0,
                "LoanTerm": productKey === 'loan' ? Number.parseInt(term) : 0,
                "AnnualMileage": Number.parseFloat(annualMileage),
                "Freight": Number.parseFloat(financialObj.freight),
                "PDE": Number.parseFloat(Number.parseFloat(financialObj.pde).toFixed(2)),
                "ACTax": withFees ? Number.parseFloat(financialObj.acTax) : 0,
                "FederalExciseTax": Number.parseFloat(financialObj.exciseTax), //`${withFees ? exciseTax : 0}
                "LeaseServiceFees": productKey === 'lease' ? Number.parseFloat(financialObj.leaseServiceFees) : 0,
                "FinanceAdminFee": productKey === 'loan' ? (withFees ? Number.parseFloat(financialObj.adminServiceFees) : 0) : 0,
                "AMVICFee": withFees ? Number.parseFloat(Number.parseFloat(financialObj.amvic).toFixed(2)) : 0,
                "OMVICFee": withFees ? Number.parseFloat(Number.parseFloat(financialObj.omvic).toFixed(2)) : 0,
                "TireStewardshipFee": withFees ? Number.parseFloat(Number.parseFloat(financialObj.tireStewardshipFee).toFixed(2)) : 0,
                "OilFilterFee": withFees ? Number.parseFloat(Number.parseFloat(financialObj.oil).toFixed(2)) : 0,
                "IsEV": withRebates,
                "CashIncentive": Number.parseFloat(Number.parseFloat(incentives).toFixed(2)),
                "WeeklyPayment": true,
                "BiWeeklyPayment": true,
                "MonthlyPayment": true,
                "MazdaAddedProtection": 0,
                "MazdaWearProtection": 0,
                "IsLoyaltyCustomer": loyaltyChecked ? true : false,
                "LoyaltyRateReduction": loyaltyChecked ? Number.parseFloat(loyaltyPriceRate) : 0,
                "LoyaltyCashIncentive": loyaltyChecked ? Number.parseFloat(Number.parseFloat(loyaltyPrice).toFixed(2)) : 0,
            }
        }
    }

    /*
        Send the data to the retrieval http service and handle some basic status error.
        
        TODO : Handle all the returned error during the refactoring phase
    */
    async sendDataToService(summaryCalculator, withFees, withRebates, productKey, term, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwner, selectedAnnualMileage) {
        const url = `${getBaseUrl()}${process.env.REACT_APP_TCCI_API_PATH}`;
        const data = this.buildBodyJson(summaryCalculator, withFees, withRebates, productKey, term, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwner, selectedAnnualMileage);

        if (Object.keys(data).length === 0) {
            console.log('No data to send to the TCCI service');
            return {};
        }

        const response = await this.handleRequest(url, data);

        return response;
    }

    /*
        Extract the lease data from the response
    */
    async extractLeaseData(response) {
        const leaseObject = {};

        leaseObject.weekly = response[0].Lease.Quote.WeeklyPayment;
        leaseObject.biWeekly = response[0].Lease.Quote.BiWeeklyPayment;
        leaseObject.monthly = response[0].Lease.Quote.MonthlyPayment;
        leaseObject.weeklyWithTaxes = response[0].Lease.Quote.WeeklyPaymentWithTaxes;
        leaseObject.biWeeklyWithTaxes = response[0].Lease.Quote.BiWeeklyPaymentWithTaxes;
        leaseObject.monthlyWithTaxes = response[0].Lease.Quote.MonthlyPaymentWithTaxes;

        // Generic information
        leaseObject.leaseRate = response[0].Lease.Quote.LeaseRate
        leaseObject.freight = response[0].Lease.Quote.Freight;
        leaseObject.pde = response[0].Lease.Quote.Pde;
        leaseObject.airConditioningTax = response[0].Lease.Quote.AirConditioningTax;
        leaseObject.omvicFee = response[0].Lease.Quote.OmvicFee;
        leaseObject.amvicFee = response[0].Lease.Quote.AmvicFee;
        leaseObject.tireStewardshipFee = response[0].Lease.Quote.TireStewardshipFee;
        leaseObject.oilFilterFee = response[0].Lease.Quote.OilFilterFee;
        leaseObject.ppsa = response[0].Lease.Quote.Ppsa;
        leaseObject.leaseDealerServiceFee = response[0].Lease.Quote.LeaseDealerServiceFee;
        leaseObject.leaseRateDiscounted = response[0].Lease.Quote.LeaseRateDiscounted;
        leaseObject.isLoyaltyCustomer = response[0].Lease.Quote.IsLoyaltyCustomer;
        leaseObject.hasError = response[0].Lease.HasError;
        leaseObject.capitalizedCost = response[0].Lease.Quote.CapitalizedCost;
        leaseObject.residualAmount = response[0].Lease.Quote.ResidualAmount;

        return leaseObject;
    }

    /*
        Extract the loan data from the response
    */
    async extractLoanData(response) {
        const loanObject = {};

        loanObject.weekly = response[0].Loan.Quote.WeeklyPayment;
        loanObject.biWeekly = response[0].Loan.Quote.BiWeeklyPayment;
        loanObject.monthly = response[0].Loan.Quote.MonthlyPayment;
        loanObject.weeklyWithTaxes = response[0].Loan.Quote.WeeklyPaymentWithTaxes;
        loanObject.biWeeklyWithTaxes = response[0].Loan.Quote.BiWeeklyPaymentWithTaxes;
        loanObject.monthlyWithTaxes = response[0].Loan.Quote.MonthlyPaymentWithTaxes;
        loanObject.costOfBorrowing = Number(response[0].Loan.Quote.CostOfBorrowingWithoutTaxes);
        loanObject.costOfBorrowingWithTaxes = Number(response[0].Loan.Quote.CostOfBorrowing);

        // GENERIC
        loanObject.freight = response[0].Loan.Quote.Freight;
        loanObject.pde = response[0].Loan.Quote.Pde;
        loanObject.airConditioningTax = response[0].Loan.Quote.AirConditioningTax;
        loanObject.omvicFee = response[0].Loan.Quote.OmvicFee;
        loanObject.amvicFee = response[0].Loan.Quote.AmvicFee;
        loanObject.tireStewardshipFee = response[0].Loan.Quote.TireStewardshipFee;
        loanObject.oilFilterFee = response[0].Loan.Quote.OilFilterFee;
        loanObject.ppsa = response[0].Loan.Quote.Ppsa;
        loanObject.aprRate = response[0].Loan.Quote.AprRate;
        //loanObject.aprRate = this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex].aprRate ? Number(this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex].aprRate).toFixed(2) : "";
        loanObject.loanPeriod = response[0].Loan.Quote.LoanPeriod; // TERM
        loanObject.aprRateDiscounted = response[0].Loan.Quote.AprRateDiscounted;
        //loanObject.aprRateDiscounted = this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex].aprRateDiscounted ? Number(this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex].aprRateDiscounted).toFixed(2) : "";
        loanObject.isLoyaltyCustomer = response[0].Loan.Quote.IsLoyaltyCustomer;
        loanObject.loanAmount = response[0].Loan.Quote.LoanAmount;
        loanObject.hasError = response[0].Loan.Quote.HasError;

        loanObject.gstAmount = response[0].Loan.Quote.GstAmount;
        loanObject.pstAmount = response[0].Loan.Quote.PstAmount;

        return loanObject;
    }

    getResidualAmountFromLeaseData(response) {
        if(response && response.length > 0)
            return response[0].Lease.Quote.ResidualAmount;
        else
            return 0;
    }
}